import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { message } from '@src/mobile/components/ModalBox';

const Input = ({ close, callback, config }) => {
    const [text, setText] = useState('');
    const { placeholder, maxSize } = config;
    const textareaRef = useRef();
    const oversizeText = `最多只能输入${maxSize}个字`;

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, []);

    const handleChange = e => {
        const { value } = e.target;

        if (value.trim().length <= maxSize) {
            setText(e.target.value);
        } else {
            message({ content: oversizeText });
        }
    };

    const handleSubmit = () => {
        const trimText = text.trim();

        if (trimText.length > 0) {
            callback(text.trim());
            close();
        } else {
            message({ content: '没有内容么？' });
        }
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.textarea}>
                <textarea value={text} onChange={handleChange} ref={textareaRef} placeholder={placeholder} />
            </div>
            <div className={styles.btnWrap}>
                <div className={styles.btnSubmit} onClick={handleSubmit}>
                    发送
                </div>
            </div>
        </div>
    );
};

Input.propTypes = {
    close: PropTypes.func,
    callback: PropTypes.func,
    config: PropTypes.object,
};

export default errorBoundary(Input);
